import React from "react";
import "../index.css";

const Header = () => {
  return (
    <nav className="nav">
      <ul>
        <li><a href="/">Home</a></li>
        <li><a href="https://www.shecodestooiq.com" target="_blank" rel="noopener noreferrer">SheCodesToo;</a></li>
      </ul>
    </nav>
  );
};

export default Header;
